const translationSpanish = {
	á: 'a',
	é: 'e',
	í: 'i',
	ó: 'o',
	ú: 'u',
	ü: 'u',
	Á: 'A',
	É: 'E',
	Í: 'I',
	Ó: 'O',
	Ú: 'U',
	Ü: 'U',
	ñ: 'n',
	Ñ: 'N',
};

export function toSlug(text) {
	// Replace the characters using replace()
	const translatedText = text.replace(
		/[áéíóúüÁÉÍÓÚÜñÑ]/g,
		(match) => translationSpanish[match]
	);
	return toKebabCase(translatedText);
}

function toKebabCase(str) {
	return str
		.replace(/\s+/g, '-')
		.replace(/([a-z])([A-Z])/g, '$1-$2')
		.toLowerCase();
}

export async function sha256(str) {
	// We transform the string into an arraybuffer.
	const buffer = new TextEncoder('utf-8').encode(str);
	const hash = await crypto.subtle.digest('SHA-256', buffer);
	return hex(hash);
}

function hex(buffer) {
	const hexCodes = [];
	const view = new DataView(buffer);

	for (let i = 0; i < view.byteLength; i += 4) {
		// Using getUint32 reduces the number of iterations needed (we process 4 bytes each time)
		const value = view.getUint32(i);
		// toString(16) will give the hex representation of the number without padding
		const stringValue = value.toString(16);
		// We use concatenation and slice for padding
		const padding = '00000000';
		const paddedValue = (padding + stringValue).slice(-padding.length);
		hexCodes.push(paddedValue);
	}

	// Join all the hex strings into one
	return hexCodes.join('');
}

export function onVisible(element, callback) {
	new IntersectionObserver((entries, observer) => {
		entries.forEach((entry) => {
			if (entry.intersectionRatio > 0) {
				callback(element);
				observer.disconnect();
			}
		});
	}).observe(element);
}

export const setInputBorderRed = (inputId) => {
	const inputField = document.getElementById(inputId);
	if (inputField) {
		inputField.style.borderColor = 'red';
	}
};
